#import "../../../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query TravelAuthorizationSecureRowLevels {
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
